type Props = {
  projectName: string;
};

const notes = [
  "Capability briefings over dashboard cards",
  "Attention-only checks instead of full status walls",
  "TL;DR first, then unlocks, then config",
];

export function ToolsSurface({ projectName }: Props) {
  return (
    <main className="ui-shell">
      <section className="ui-hero">
        <div className="ui-kicker">tools briefing</div>
        <h1>Tools should read like operator notes, not admin panels.</h1>
        <p>
          This frontend route is the migration target for the Rust tools page. The goal is a
          single readable sheet with clean metadata, softer motion, and component-driven layout.
        </p>
        <div className="ui-tags">
          <span>{projectName}</span>
          <span>global + project state</span>
          <span>magic-ui migration</span>
        </div>
      </section>
      <section className="ui-list">
        {notes.map((note) => (
          <div key={note} className="ui-row">
            {note}
          </div>
        ))}
      </section>
    </main>
  );
}
